function Minus({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '14'} height=${dimensions / 7 || '2'} viewBox="0 0 14 2" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 2H0V0H14V2Z" fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default Minus;
